import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=1d985a64&"
import script from "./TagsComponent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TagsComponent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports